import Component from './InstagramPostFilter.vue'
export default Component
